/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { TextPanel } from 'components/textPanel'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Link } from '@ta-interaktiv/contentbricks'
import { ArticleTeasers, SortMode } from '@ta-interaktiv/react-article-teasers'

const ARTICLE_ID = '862347686215'
const isMobile = window.innerWidth < 600

export function AppComponent() {
  const [textPanelOpen, setTextPanelOpen] = useState(false)
  const [textData, setTextData] = useState(['Title', 'Content', []])
  const version = '1.35'
  const publication = window.location.hostname.split('.')[1]
  console.log(publication)
  const links = {
    tdg: ['17116439', '25972118'],
    '24heures': ['10596761', '30724783']
  }

  if (window.localStorage.getItem('version') !== version) {
    window.localStorage.clear()
    window.localStorage.version = version
  }

  const getPublicationLink = (publication, id) => {
    let out = links.tdg[id]
    if (links[publication]) {
      out = links[publication][id]
    }
    return out
  }

  return (
    <div className='index'>
      <Masthead inverted articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header
        className='ui vertical segment'
        /* style={{
          backgroundImage:
            'url(' + require('../../images/cover-full-back.svg') + ')'
        }} */
      >
        <div className='ui container'>
          <div className='ui inverted header'>
            <h1>Explorez la galaxie Maudet</h1>
            <h2>
              Deux ans après ses premiers frémissements, l'Affaire Maudet n'en
              finit pas de secouer Genève. Des révélations de la Tribune de
              Genève à l'ouverture d'une procédure judiciaire et l'exclusion du
              PLR,{' '}
              <span className='colored'>
                naviguez dans les méandres d'un dossier
              </span>{' '}
              aussi complexe que passionnant.
            </h2>
          </div>
          {/* <div className='illustration-wrapper'>
            <div
              className='illustration-front'
              style={{
                backgroundImage:
                  'url(' + require('../../images/cover-full-front.svg') + ')'
              }}
            />
            </div> */}
        </div>
      </header>

      <TextPanel
        title={textData[0]}
        content={textData[1]}
        links={textData[2]}
        open={textPanelOpen}
        onClose={() => {
          setTextPanelOpen(false)
          document.body.classList.remove('modal-open')
        }}
        onOpen={() => {
          document.body.classList.add('modal-open')
        }}
      />

      <div className='ui vertical segment'>
        <div className='ui inverted text container'>
          <div className='ta metainfo'>
            <div className='ta author'>
              Cécile Denayrouse, Olivier Francey, Mathieu Rudaz
            </div>
            <div className='ta updated'>Mis à jour le 29 août 2020</div>
          </div>
          <div className='ta text'>
            <p>
              Il s'agit de l'un des plus grands séïsmes démocratiques suisses.
              L'animal politique Pierre Maudet, enfant prodige du parti radical
              genevois, loué pour sa force de travail et sa connaissance des
              dossiers, longtemps promis aux plus grandes destinées, est
              désormais en mauvaise posture. La Justice reproche au ministre
              genevois d'avoir{' '}
              <Link href={getPublicationLink(publication, 0)}>
                accepté des cadeaux
              </Link>{' '}
              que sa fonction lui imposait de refuser. En outre, il a
              volontairement caché certaines informations au grand public.
              Refusant de quitter le pouvoir, l'élu PLR va remettre d'ici peu
              entre les mains des juges à la fois sa réputation, son avenir
              politique et son poste de Conseiller d'État.
            </p>
            <p>
              Pour mieux comprendre les tenants et aboutissants de ce dossier
              hors-norme, explorez à travers une mise en scène innovante les
              différents volets de ce qui restera dans l'histoire romande comme
              «l'Affaire Maudet».
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment screen-scroll-canvas'>
        <TypescriptComponent
          isTextPanelOpen={textPanelOpen}
          onTextOpen={(title, content, links) => {
            setTextPanelOpen(true)
            setTextData([title, content, links])
          }}
        />
      </div>
      <div id='article-next' />
      <Footer
        inverted
        hidePortfolioTeaser
        locale='fr'
        articleId={ARTICLE_ID}
        credits={[
          ['Textes', 'Céciles Denayrouse, Olivier Francey'],
          ['Conception', 'Mathieu Rudaz, Océane Haenni']
        ]}
        title='Comment jugez-vous ce contenu?'
        questions={[
          'Était-il informatif?',
          'La mise en oeuvre technique a-t-elle fonctionné?',
          'La mise en forme vous plaît-elle?',
          'Voudriez-vous voir davantage de ce type de contenu?'
        ]}
        mailTo='mathieu.rudaz@tamedia.ch'
      >
        <div className='ui vertical inverted segment'>
          <div
            className='ui container'
            style={{ margin: isMobile ? '1.2em 0 3em' : '0 0 3em' }}
          >
            <h4 className='inverted teaser'>Plus d'articles sur ce thème</h4>
            <ArticleTeasers
              numberOfCards='three'
              sorting={SortMode.REVERSE_CHRONOLOGICALLY_BY_CREATION_DATE}
              articleIds={[
                '17116439',
                '10596761',
                '25972118',
                '30724783',
                '29229447',
                '24957686',
                '12556952',
                '19259408',
                '652976218986',
                '450719502706'
              ]}
            />
          </div>
        </div>
      </Footer>
    </div>
  )
}
